"use strict";

import React, {useEffect, useRef, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import FormSelect from "../../component/FormSelect";
import ReCAPTCHA from "react-google-recaptcha";
import Cleave from "cleave.js/react";
import emailValidator from "email-validator";
import ContactFormErrors from "./ContactFormErrors"
import ReturnPolicy from "../../component/ReturnPolicy";

const recaptchaRef = React.createRef();


const ContactForm = ({
    recaptchaKey = '',
    contactUsAction = '',
    lookupAction = '',
    myAccountUrl = '',
    requestCatalogUrl = '',
    handleFormSubmit = (url, data) => {},
    formErrors = {}
}) => {
    const [showReturnPolicy, setShowReturnPolicy]   = useState(false);
    const [showOrderField, setShowOrderField]       = useState(false);
    const [showItemNumber, setShowItemNumber]       = useState(false);
    const [showQuantity, setShowQuantity]           = useState(false);
    const [messageLabel, setMessageLabel]           = useState("Your message");
    const [subjectValue, setSubjectValue]           = useState("");
    const [hideContactForm, setHideContactForm]     = useState(false);
    const [showStatusMessage, setShowStatusMessage] = useState(false);
    const [submitLabel, setSubmitLabel]             = useState('Send us a message')
    const [formEndpoint, setFormEndpoint]           = useState(contactUsAction);

    const scrollTo = useRef(null);

    const {
        register,
        handleSubmit,
        watch,
        control,
        setValue,
        setError,
        clearErrors,
        getValues,
        reset,
        formState: {errors, isSubmitting}
    } = useForm();

    const watchSubject = watch('message_subject_type', '');

    const subjects = [
        {
            value: '',
            label: 'Choose a subject'
        },
        {
            value: 'tracking',
            label: 'Track my shipment'
        },
        {
            value: 'status',
            label: 'Order status'
        },
        {
            value: 'return',
            label: 'Returns and refunds'
        },
        {
            value: 'feedback',
            label: 'Customer Feedback'
        },
        {
            value: 'product',
            label: 'Product Questions (General, Digital, E-File)'
        },
        {
            value: 'catalog',
            label: 'Request a catalog'
        },
        {
            value:    'others',
            label:    'Others',
            children: [
                {
                    value: 'reorder',
                    label: 'Reordering'
                },
                {
                    value: 'general',
                    label: 'General'
                },
            ]
        },
    ];

    useEffect(()=>{
        try {
            const params = new URL(document.location).searchParams;
            const paramsSubject = params.get('subject') || '';
            console.log('paramsSubject-1:', paramsSubject);
            if(!!paramsSubject){
                console.log('paramsSubject-2:', paramsSubject);
                //setSubjectValue(()=>paramsSubject);
                reset({...getValues(), message_subject_type: paramsSubject,});
            }
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        clearErrors();
        recaptchaRef.current.reset();
        for (const [key, value] of Object.entries(formErrors)) {
            let types = {};
            value.forEach((e,i) => {
                types['apiError'+i] = e;
            });

            setError(key, {...types});
        }
        executeScroll();
    }, [formErrors]);

    useEffect(() => {
        handleSubjectChange(watchSubject);
    }, [watchSubject]);

    useEffect(() => {
        console.log(errors);
    }, [errors]);

    const executeScroll = () => scrollTo.current.scrollIntoView();

    const onSubmit = (data) => {
        clearErrors();
        return handleFormSubmit(formEndpoint, data);
    }

    const recaptchaChange = (value) => {
        setValue('g-recaptcha-response', value);
        clearErrors('g-recaptcha-response');
    }

    const onSubmitClick = (event) => {
        if (Object.keys(errors).length > 0) {
            clearErrors()
        }
        console.log(errors);
    }

    const handleSubjectChange = (subject) => {

        setSubjectValue(subject);
        setShowReturnPolicy(false);
        setShowOrderField(false);
        setShowItemNumber(false);
        setShowQuantity(false);
        setMessageLabel('Your message');
        setSubmitLabel('Send us a message')
        setShowStatusMessage(false);
        setHideContactForm(false);
        setFormEndpoint(contactUsAction);

        switch (subject) {
            case 'return':
                setShowItemNumber(true);
                setShowQuantity(true);
                setShowReturnPolicy(true);
                setShowOrderField(true);
                setMessageLabel('Reason for return')
                break;
            case 'product':
                setShowItemNumber(true);
                setMessageLabel('Product question')
                break;
            case 'tracking':
            case 'status':
                setShowOrderField(true);
                setHideContactForm(true);
                setShowStatusMessage(true);
                setFormEndpoint(lookupAction);
                setSubmitLabel('Look up order')
                break;
            case 'catalog':
                window.location = requestCatalogUrl;
                break;
            default:
                break;

        }
    }

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            noValidate
        >

            <div ref={scrollTo}>
                <ContactFormErrors errors={errors['contact-company']}></ContactFormErrors>
            </div>


            <fieldset>
                <legend>Send us a message</legend>
                <p className="required_input_info">
                    All fields marked with an asterisk (<span className="label__required"></span>) are required
                </p>
                <ol className="form__input-list">
                    <li className="form__input-list-item">
                        <label htmlFor="message-subject-type">Subject</label>
                        <Controller
                            name="message_subject_type"
                            control={control}
                            rules={{required: 'Subject is required'}}
                            render={({
                                field: {
                                           onChange,
                                           onBlur,
                                           value
                                       }
                            }) =>
                                <FormSelect
                                    name="message_subject_type"
                                    id="message_subject_type"
                                    options={subjects}
                                    onBlur={onBlur}
                                    value={value}
                                    onChange={(event) => {
                                        onChange(event);
                                    }}
                                />
                            }
                        />
                        <ContactFormErrors errors={errors['message_subject_type']}></ContactFormErrors>
                        {showReturnPolicy &&
                            <>
                                <div style={{paddingTop: '1.25rem',marginBottom: '1.25rem',}}>
                                    <ReturnPolicy />
                                </div>
                                <h3>Return Merchandise Form</h3>
                                <p>Please fill out the form below to let us know what you would like to return.</p>
                            </>
                        }
                    </li>
                    {!hideContactForm &&
                        <>
                            <li className="form__input-list-item">
                                <label htmlFor="customer_name" className="label__required">Customer Name</label>
                                <input type="text" id="customer_name" {...register('customer_name', {
                                    required:  'Customer name is required',
                                    minLength: 'Customer name must be at least 5 characters long',
                                    maxLength: 'Customer name must be less than 40 characters long'
                                })}/>
                                <ContactFormErrors errors={errors['customer_name']}></ContactFormErrors>
                            </li>
                            <li className="form__input-list-item">
                                <label htmlFor="contact_name" className="label__required">Contact Name</label>
                                <input type="text" id="contact_name" {...register('contact_name', {
                                    required:  'Contact name is required',
                                    minLength: 'Contact name must be at least 5 characters long',
                                    maxLength: 'Contact name must be less than 40 characters long'
                                })}/>
                                {!!errors['contact_name'] &&
                                    <small className="form__error">
                                        {errors['contact_name'].message}
                                    </small>
                                }
                            </li>
                            <li className="form__input-list-item">
                                <label htmlFor="business_phone" className="label__required">Business Phone</label>
                                <Controller
                                    name="business_phone"
                                    control={control}
                                    rules={{
                                        required:  'Business phone is required',
                                        minLength: 'Business phone must be in the format of 555.555.5555',
                                        maxLength: 'Business phone must be in the format of 555.555.5555'
                                    }}
                                    render={({
                                        field: {
                                                   onChange,
                                                   onBlur,
                                                   value,
                                               },
                                    }) =>
                                        <Cleave id="business_phone"
                                                name="business_phone"
                                                options={{
                                                    delimiter:   '.',
                                                    blocks:      [3, 3, 4],
                                                    numericOnly: true,
                                                }}
                                                value={value}
                                                onBlur={onBlur}
                                                onChange={onChange}
                                        />
                                    }
                                />
                                <ContactFormErrors errors={errors['business_phone']}></ContactFormErrors>
                            </li>
                            <li className="form__input-list-item">
                                <label htmlFor="contact_phone">Contact Phone (if different than Business)</label>
                                <Controller
                                    name="contact_phone"
                                    control={control}
                                    rules={{
                                        minLength: 'Contact phone must be in the format of 555.555.5555',
                                        maxLength: 'Contact phone must be in the format of 555.555.5555'
                                    }}
                                    render={({
                                        field: {
                                                   onChange,
                                                   onBlur,
                                                   value,
                                               },
                                    }) =>
                                        <Cleave id="contact_phone"
                                                name="contact_phone"
                                                options={{
                                                    delimiter:   '.',
                                                    blocks:      [3, 3, 4],
                                                    numericOnly: true,
                                                }}
                                                value={value}
                                                onBlur={onBlur}
                                                onChange={onChange}
                                        />
                                    }
                                />
                                <ContactFormErrors errors={errors['contact_phone']}></ContactFormErrors>
                            </li>
                        </>
                    }
                    {showOrderField &&
                        <li className="form__input-list-item">
                            <label htmlFor="order_invoice_number" className="label__required">Order/Invoice
                                Number</label>
                            <input type="text" id="order_invoice_number" {...register('order_invoice_number',
                                {required: "You must provide an Order or Invoice number"})}/>
                            {!!errors['order_invoice_number'] &&
                                <small className="form__error">
                                    {errors['order_invoice_number'].message}
                                </small>
                            }
                            {showStatusMessage &&
                                <div>
                                    <p>Please enter your Order/Invoice number to see your order {subjectValue}</p>
                                    <p>
                                        If you do not know your Order/Invoice number you can head to&nbsp;
                                        <a href={myAccountUrl}>your account</a> to check the order {subjectValue} there.
                                    </p>
                                </div>
                            }
                        </li>
                    }

                    {showItemNumber &&
                        <li className="form__input-list-item">
                            <label
                                htmlFor="item_number"
                                className="label__required">
                                Item Number
                            </label>
                            <input type="text" id="item_number" {...register('item_number',
                                {required: "You must provide a valid item number"})}/>
                            <ContactFormErrors errors={errors['item_number']}></ContactFormErrors>
                        </li>
                    }
                    {showQuantity &&
                        <li className="form__input-list-item">
                            <label
                                htmlFor="quantity"
                                className="label__required">
                                Quantity
                            </label>
                            <input type="text" id="quantity" {...register('quantity',
                                {required: "You must provide a valid quantity"})}/>
                            <ContactFormErrors errors={errors['quantity']}></ContactFormErrors>
                        </li>
                    }

                    <li className="form__input-list-item">
                        <label htmlFor="message_email" className="label__required">Email</label>
                        <input type="text" id="message_email" {...register('message_email', {
                            required: "Email address is required",
                            validate: emailValidator.validate
                        })}/>
                        <ContactFormErrors errors={errors['message_email']}></ContactFormErrors>
                    </li>
                    {!hideContactForm &&
                        <>
                            <li className="form__input-list-item">
                                <label htmlFor="message_text" className="label__required">{messageLabel}</label>
                                <textarea id="message_text" {...register('message_text', {
                                    required:  "You must provide a message for customer support",
                                    minLength: "Your message must be at least 4 characters long"
                                })}/>
                                <ContactFormErrors errors={errors['message_text']}></ContactFormErrors>
                            </li>
                        </>
                    }
                </ol>
            </fieldset>
            <fieldset>
                <ol className="form__input-list">
                    <li className="form__input-list-item">

                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={recaptchaKey}
                            onChange={recaptchaChange}
                        />
                        <input type={"hidden"} {...register('g-recaptcha-response', {required: true})} />
                        <ContactFormErrors errors={errors['g-recaptcha-response']}></ContactFormErrors>
                    </li>
                </ol>
            </fieldset>

            <fieldset className={"form__fieldset-submit" + (isSubmitting ? ' loading loading--w-flip loading--center' : '')}>
                {(!hideContactForm || showStatusMessage) && <>
                    <input type="submit" disabled={isSubmitting} onClick={onSubmitClick} name="customer-contact-company" value={submitLabel}
                           className="btn__secondary"/>
                </>}
            </fieldset>
        </form>
    );

};

export default ContactForm;